import {ToastComponentI} from "./toast-component.interface";
import {Component, input, output} from "@angular/core";

@Component({
    template: ""
})
export class ToastComponent implements ToastComponentI {

    message = input<string>("");
    outputPredicate = input<()=>any>( ()=> undefined );
    close = output<any>( );

    doClose(): any {
        console.error("Not implemented");
    }

}